import { Component } from "../../../../../component-decorator";
import { UiRouterState } from "src/app/services/ajs-router-state.service";

declare var $;

@Component({
  componentName: "appReverseAddressesForm",
  template: require("./reverse-addresses-form.html"),
  controllerAs: "vm",
  bindings: {
    original: "<",
    recipients: "<",
    reverse: "<",
    reset: "<",
    user: "<",
    canShowOptionsChange: "<",
    deliveryTypesChange: "<",
    reverseService: "<?",
    fixedModalidade: "@?",
    documentoObrigatorio: "<?",
  },
})
export class ReverseAddressesFormComponent implements angular.IController {
  // Input parameters
  public original;
  public recipients;
  public reverse;
  public user;
  // Serviço de reversa (tipos de entrega). Quando ausente, usa o Historico (pedido-services).
  public reverseService;
  // Quando informada, fixa a modalidade e oculta o campo (usado pela v2).
  public fixedModalidade: string;
  // Quando true, exige o CPF/CNPJ do remetente e o exibe antes do telefone (usado pela v2).
  public documentoObrigatorio: boolean;

  // Output events
  public reset: () => void;
  public canShowOptionsChange: (newValue: boolean) => void;
  public deliveryTypesChange: (newValue: any[]) => void;

  // State vars
  public addressesForm;
  public buscandoEnderecoOn = false;
  public buscandoOriginalOn = false;
  public buscandoTiposEntregaOn = false;

  private _canShowOptions = false;
  public get canShowOptions() {
    return this._canShowOptions;
  }
  public set canShowOptions(value: boolean) {
    this._canShowOptions = value;
    if (typeof this.canShowOptionsChange === "function") {
      this.canShowOptionsChange(value);
    }
  }

  private _deliveryTypes = [];
  public get deliveryTypes() {
    return this._deliveryTypes;
  }
  public set deliveryTypes(value: any[]) {
    this._deliveryTypes = value;
    if (typeof this.deliveryTypesChange === "function") {
      this.deliveryTypesChange(value);
    }
  }

  public originalPackage = null;
  public originalPackageTrackingCode: string = null;
  public isCodigoPostalPreenchido = false;
  public showPickupSchedule = false;
  public showColetaDomiciliar = false;
  public fromPackage = false;
  public pickupDates;
  public selectedRecipient;

  public alterouEnderecoCorreios = false;
  public ruaOn;
  public numeroOn;
  public complementoOn;

  constructor(
    private Endereco,
    private Historico,
    private Pedido,
    private Perfil,
    private $filter,
    private $mdToast,
    private $uibModal,
    public $state: UiRouterState
  ) {
    "ngInject";
  }

  public async $onInit() {
    this.clearOriginalPackage();

    this.fromPackage =
      this.original && this.original.packageId && this.original.orderId
        ? true
        : false;

    if (this.fixedModalidade) {
      this.reverse.modalidade = this.fixedModalidade;
    } else {
      this.Perfil.getBetaFeatures().then((data) => {
        this.showColetaDomiciliar = data["funcionalidades"].find(
          (feature) => feature.codigo === "reversa-coleta-domiciliar"
        ).possuiAcesso;
      });
    }

    if (this.fromPackage) {
      try {
        this.originalPackage = await this.Historico.getPackage(this.original);
        this.originalPackage.destinatario.nome =
          this.originalPackage.destinatario.nomeCompleto;
        this.originalPackage.destinatario.endereco.uf =
          this.originalPackage.destinatario.endereco.estado;
        this.fillWithOriginalPackage();
      } catch (err) {
        console.log(err);
        this.fromPackage = false;
      }
    }

    this.loadPickupDates();
  }

  public async getReverseDeliveryTypes() {
    if (this.addressesForm.$valid) {
      this.buscandoTiposEntregaOn = true;

      this.addressesForm.$submitted = false;

      try {
        const data = await (this.reverseService || this.Historico).getReverseDeliveryTypes(
          this.reverse.remetente,
          this.reverse.destino,
          this.reverse.modalidade
        );
        this.deliveryTypes = data;
        this.canShowOptions = true;
      } catch (err) {
        console.log(err);
        this._showAlert(
          "Tente novamente dentro de alguns minutos. O serviço de logística reversa está indisponível neste momento."
        );
      } finally {
        this.buscandoTiposEntregaOn = false;
      }
    } else {
      this._showAlert("Ops, alguns campos não foram preenchidos corretamente");
    }
  }

  public onRecipientChange() {
    if (!this.reverse) {
      return;
    }

    this.reverse.destino = this.selectedRecipient;
  }

  public clearAddressForm() {
    const codigoRastreamentoOriginalPackage =
      this.originalPackage.codigoRastreamento;
    this.originalPackage = {
      codigoRastreamento: codigoRastreamentoOriginalPackage,
    };
    this.reverse.remetente = {};
    this.reverse.remetente.endereco = {};
    this.isCodigoPostalPreenchido = false;
    this.canShowOptions = false;
  }

  public clearOriginalPackage() {
    this.reset();

    this.originalPackage = null;
    this.originalPackageTrackingCode = null;
    this.isCodigoPostalPreenchido = false;
    this.canShowOptions = false;
  }

  public removeSpacesFromCodigoRastreamento() {
    if (!this.originalPackage || !this.originalPackage.codigoRastreamento) {
      return;
    }

    this.originalPackage.codigoRastreamento =
      this.originalPackage.codigoRastreamento.replace(/\s/g, "");
  }

  public async searchOriginalPackage() {
    if (!this.originalPackage || !this.originalPackage.codigoRastreamento) {
      return this._showAlert(
        "Não é possível pesquisar por encomenda sem código de rastreamento"
      );
    }

    this.buscandoOriginalOn = true;
    let data;
    try {
      data = await this.Historico.getListaEncomendas(
        { rastreamento: this.originalPackage.codigoRastreamento },
        0,
        1
      );
    } catch (err) {
      this._showAlert(
        "Não foi possível pesquisar pelo código de rastreamento informado"
      );
      this.clearAddressForm();
      this.buscandoOriginalOn = false;
      return;
    }

    const originalPackageFound = data.pedidos
      .filter(
        (pkg) =>
          pkg.codigoRastreamento === this.originalPackage.codigoRastreamento
      )
      .shift();

    if (!originalPackageFound) {
      $("p.original-package").text(
        "Nenhuma encomenda foi encontrada para esse código de rastreamento."
      );
      this.buscandoOriginalOn = false;
      this.clearAddressForm();
      return;
    }

    if (
      !["Entregue", "Enviada", "AguardandoRetiradaDestinatario"].includes(
        originalPackageFound.codigoSituacao
      )
    ) {
      $("p.original-package").text(
        "Esta encomenda ainda não foi entregue, por isso não podemos usá-la aqui."
      );
      this.buscandoOriginalOn = false;
      this.clearAddressForm();
      return;
    }

    $("p.original-package").text(
      'Informe o rastreamento de uma encomenda na situação "entregue".'
    );
    this.originalPackage = originalPackageFound;
    this.originalPackage.destinatario.endereco.codigoPostal =
      this.originalPackage.destinatario.endereco.cep;
    this.fillWithOriginalPackage();
    this.buscandoOriginalOn = false;
  }

  public async getLocation(address) {
    this.buscandoEnderecoOn = true;
    if (!isNaN(address.replace("-", ""))) {
      address = address.replace("-", "");
    }

    try {
      const data = await this.Endereco.getAddress(address.toLowerCase());
      this.buscandoEnderecoOn = false;
      // reseta variaveis de focus
      this.ruaOn = null;
      this.numeroOn = null;
      this.complementoOn = null;

      if (data.usouSugestao) {
        const sugestao = data.enderecosEncontrados;
        const obj = {
          enderecoFormatado:
            "Se você não encontrou o endereço, busque pelo CEP",
          desabilita: true,
        };
        sugestao.unshift(obj);
        return sugestao;
      }

      return data.enderecosEncontrados;
    } catch (err) {
      this.buscandoEnderecoOn = false;
      // vm.tratarErrosBackEnd(err);
      const erroFormatado = [
        { enderecoFormatado: err.data.erro, desabilita: true },
      ];

      return erroFormatado;
    }
  }

  public preencheEndereco(item, model, label, event) {
    if (item.desabilita) {
      this.reverse.remetente.endereco.codigoPostal = null;
    } else {
      if (!item.logradouro) {
        this.ruaOn = true;
      } else if (!item.numero) {
        this.numeroOn = true;
      } else {
        this.complementoOn = true;
      }

      this.isCodigoPostalPreenchido = true;
      this.alterouEnderecoCorreios = false;

      this.reverse.remetente.endereco.codigoPostal = item.cep;
      this.reverse.remetente.endereco.logradouro = item.logradouro;
      this.reverse.remetente.endereco.numero = item.numero ? item.numero : null;
      this.reverse.remetente.endereco.bairro = item.bairro;
      this.reverse.remetente.endereco.cidade = item.cidade;
      this.reverse.remetente.endereco.uf = item.estado;
    }
  }

  public formatCodigoPostal(codigoPostal) {
    return this.$filter("cep")(codigoPostal);
  }

  public changeEnderecoCorreios() {
    this.alterouEnderecoCorreios = true;
  }

  public ehPessoaJuridica() {
    return (
      this.reverse.remetente &&
      this.reverse.remetente.documento &&
      this.reverse.remetente.documento.length === 14
    );
  }

  public showNewRecipientAddressModal() {
    // tslint:disable-next-line:no-unused-expression
    this.$uibModal.open({
      animation: false,
      template: require("../new-recipient-address/new-recipient-address.html"),
      controller: "ReverseNewRecipientAddressCtrl",
      controllerAs: "vm",
      windowClass: "new-recipient-address",
      resolve: {
        id: () => "empty",
      },
    }).result;
  }

  public cancelAction() {
    this.$uibModal
      .open({
        animation: false,
        template: require("../cancel-panel/cancel-panel.html"),
        controller: "ReverseCancelCtrl",
        controllerAs: "vm",
        windowClass: "cancel-panel",
        resolve: {
          id: function () {
            return "empty";
          },
        },
      })
      .result.then(function (data) {
        window.history.back();
      });
  }

  private fillWithOriginalPackage() {
    const recipientAddress = this.originalPackage.destinatario.endereco;

    this.reverse.remetente = {
      nome: this.originalPackage.destinatario.nome,
      documento: this.originalPackage.destinatario.documento,
      inscricaoEstadual: this.originalPackage.destinatario.inscricaoEstadual,
      email: this.originalPackage.destinatario.email,
      endereco: {
        codigoPostal: recipientAddress.codigoPostal.replace(/-/g, ""),
        logradouro: recipientAddress.logradouro,
        numero: recipientAddress.numero,
        complemento: recipientAddress.complemento,
        bairro: recipientAddress.bairro,
        cidade: recipientAddress.cidade,
        uf: recipientAddress.uf,
        pais: recipientAddress.pais,
        referencia: recipientAddress.referencia,
      },
    };

    if (this.originalPackage.destinatario.telefone) {
      this.reverse.remetente.telefone =
        this.originalPackage.destinatario.telefone.replace(/\D/g, "");
    }

    this.isCodigoPostalPreenchido = true;
  }

  private async loadPickupDates() {
    this.pickupDates = await this.Pedido.datasProximasUteis(10, 5);
  }

  private _showAlert(content) {
    const toast = this.$mdToast
      .simple()
      .textContent(content)
      .highlightAction(true)
      .parent('[data-container="toast"]')
      .position("top right")
      .hideDelay(5000);

    return this.$mdToast.show(toast);
  }
}
